import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Container,
  Label,
  Progress,
  Row,
  Spinner,
  Input,
} from "reactstrap";
import * as Yup from "yup";
import { useRole } from "components/Hooks/UserHooks";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import { postStaff, putStaff } from "store/staff/thunk";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import {
  COLOR_BAR_DETAIL_REVIEW_STATUS,
  COLOR_BAR_DETAIL_STAFF_APPROVED_STATUS,
  LIST_OPTION_BAR_DETAIL_REVIEW_STATUS,
  LIST_OPTION_BAR_DETAIL_STAFF_APPROVED_STATUS,
  LIST_OPTION_TYPE_BARTENDER,
  LIST_OPTION_GENDER,
  COLOR_TYPE_BARTENDER,
  ENUM_TYPE_BARTENDER,
} from "helpers/constans";
import DatePicker, { registerLocale } from "react-datepicker";
import { getUser } from "store/thunks";
import UploadImageSingle from "components/Common/UploadImageSingle";
import Keywords from "components/Common/Keywords";
import ModalHashTag from "components/Common/ModalHashTag";
import DropdownAsyncBartenderNoBar from "components/Common/DropdownAsyncBartenderNoBar";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";

export interface Props {
  id?: string;
  triggerRefresh?: () => void;
  setLinkImage?: any;
  isCloseModal?: any;
  rowSelected?: any;
  barId?: string;
  listHashtag?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const StaffForm = ({
  id = "",
  triggerRefresh,
  setLinkImage,
  isCloseModal,
  rowSelected,
  barId,
  listHashtag
}: Props) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingDetail, setIsLoadingDetail] = useState<boolean>(false);
  const [selectedUserForStaff, setSelectedUserForStaff] = useState<any>(null);
  const [isOpenHashTag, setIOpenHashTag] = useState<boolean>(false);
  const [initialValueHashTag, setInitialValueHashTag] = useState<any>([]);
  const [isFirstProgress, setIsFirstProgress] = useState<boolean>(true);

  const handleSubmit = async (values: any) => {
    if (!barId) return;

    try {
      isCloseModal && isCloseModal();
      setIsLoading((_prev) => true);
     
      const formatHashtag = values?.hashtags ? values?.hashtags?.map((item: any) => {
        return {
          content: item?.content || item?.text,
          normal_text_color: item?.normal_text_color || '#333333',
          active_text_color: item?.active_text_color || '#ffffff',
          normal_background_color: item?.normal_background_color || '#f5f5f5',
          active_background_color: item?.active_background_color || '#4a4a4a'
        }
      }) : [];

      let data: any = {
        // ...values,
        bar_id: barId,
        approved_status: values?.approved_status,
        name: values?.name,
        phone: values?.phone,
        image: values?.image,
        staff_type: values?.staff_type,
        gender: values?.gender,
        status: values?.status,
        bio: values?.bio,
        started_at: formatDateStringToUTC(values.started_at),
        hashtags: formatHashtag,
        ...(values?.user_id ? {user_id: values?.user_id} : null)
      };


      if (id) {
        delete data.bar_id;
        delete data.user_id;
      }
      // console.log(data)

      const response: any = id
        ? await putStaff(id, data)
        : await postStaff(data);

      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(`${t("This field is required")}`),
    started_at: Yup.string().required(`${t("This field is required")}`),
    hashtags: Yup.array()
      .max(3, `${t("You can only select a maximum of 3 hashtags")}`)
      .when("image", {
        is: (value: any) => !value,
        then: (rule) => {
          return rule.test(
            "image",
            `${t("This field is required")}`,
            (target) => {
              const hashtag = target || [];
              if(hashtag?.length > 0 ) return true;
              return false
            }
          ).test(
            "image",
            `${t("You must choose 3 hashtags")}`,
            (target) => {
              const hashtag = target || [];
              if(hashtag?.length < 3 ) return false;
              return true
            }
          );
        },
      }),
  });

  const formik = useFormik({
    initialValues: {
      user_id: "",
      name: "",
      bio: "",
      image: null,
      gender: "female",
      staff_type: LIST_OPTION_TYPE_BARTENDER?.[1]?.value,
      phone: "",
      started_at: new Date() || '',
      approved_status: 1,
      status: 1,
      hashtags: []
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const getUserDetail = async (id: string) => {
    const resUser: any = await getUser(id);

    if (resUser?.data) {
      const vUser = resUser?.data;
      let vUserOption: any = vUser ? (
        {
          value: vUser?.user_id,
          label: (
            <div className="d-flex align-items-center gap-2">
              <div>{`${vUser?.nickname ? vUser?.nickname + " -" : ""} ${
                vUser?.email
              }`}</div>
            </div>
          ),
        }
      ) : (
        <></>
      );

      formik.setFieldValue("user_id", vUser?.id || "");
      setSelectedUserForStaff(vUserOption);
    }
  };

  const handleCloseHashTag = () => {
    setIOpenHashTag(false)
  };

  const handleConfirmHashTag = (hashtags: any) => {
    const newHashtag = [...hashtags.map((item: any) => ({
      ...item,
      id: item?.content?.toLowerCase() || item?.id,
      text: item?.content || item?.text
    }))];

    setInitialValueHashTag(newHashtag);
    formik.setFieldValue("hashtags", newHashtag)
    setIOpenHashTag(false)
  };

  useEffect(() => {
    if (rowSelected) {
      formik.setFieldValue("bar_id", rowSelected?.bar_id || "");
      formik.setFieldValue("name", rowSelected?.name || "");
      formik.setFieldValue("gender", rowSelected?.gender || "");
      formik.setFieldValue("bio", rowSelected?.bio || "");
      formik.setFieldValue("phone", rowSelected?.phone || "");
      formik.setFieldValue("image", rowSelected?.image || "");
      formik.setFieldValue("status", rowSelected?.status);
      formik.setFieldValue("staff_type", rowSelected?.staff_type);
      formik.setFieldValue("approved_status", rowSelected?.approved_status);
      formik.setFieldValue("started_at", rowSelected?.started_at ? new Date(formatDateStringToKorea(rowSelected.started_at)) : null);
      
      if (rowSelected?.user_id) {
        getUserDetail(rowSelected?.user_id);
      }

      if(rowSelected?.hashtags?.length > 0) {
        const formatData = rowSelected?.hashtags?.map((item: any) => {
          return {
            ...item,
            id: item?.content,
            text: item?.content
          }
        });
        formik.setFieldValue("hashtags", formatData);
      }
    }
  }, [rowSelected]);

  useEffect(() => {
    document.title = `${t("Staff")} - ${t("Bar Detail")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      setIsFirstProgress(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(formik.errors).length]);
  
  return (
    <React.Fragment>
      {isLoadingDetail && (
        <div
          style={{
            position: "absolute",
            zIndex: 3,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgb(164 164 164 / 36%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner size="sm" color="primary"></Spinner>
        </div>
      )}
      <div>
        <Container fluid className="px-0">
          <div className="mb-4">
            <Progress
              value={
                !isFirstProgress || !!id
                  ? 100 - (100 / 2) * Number(Object.keys(formik.errors).length)
                  : 0
              }
              color="primary"
              className="animated-progress progress-sm"
            />
          </div>
          <form onSubmit={formik.handleSubmit}>
            <Row>
              <Col xxl={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Type")}</Label>

                  <DropdownStatusNew
                    name="staff_type"
                    dataList={LIST_OPTION_TYPE_BARTENDER || []}
                    placeholder={`${t("Type")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.staff_type || null}
                    onChangeSelect={(e: any) => {
                      formik.setFieldValue("staff_type", e?.value)
                      if(e?.value === ENUM_TYPE_BARTENDER.SYSTEM && !id) {
                        formik.setFieldValue("name", '');
                        formik.setFieldValue("user_id", '');
                        setSelectedUserForStaff(null);
                      }
                    }}
                    isHasOptionAll={false}
                    colors={COLOR_TYPE_BARTENDER}
                    disabled={false}
                  />
                  
                  {formik?.touched?.staff_type && formik?.errors?.staff_type ? (
                    <div className="text-danger mt-2">
                      {/* {formik?.errors?.level} */}
                    </div>
                  ) : null}
                </div>
              </Col>

              {
                formik?.values?.staff_type === 2 && (
                  (
                    <>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label htmlFor="name" className="form-label">
                            {t("Users")}
                          </Label>
  
                          <DropdownAsyncBartenderNoBar
                            name="user_id"
                            onChangeSelect={(event: any) => {
                              formik.setFieldValue("user_id", event?.value);
                              formik.setFieldValue("name", event?.data?.nickname || '');
                              formik.setFieldValue("avatar", event?.data?.profile_image_url || '');
                              setSelectedUserForStaff(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select User")}...`}
                            isShowIconCheck={false}
                            isAllOption={false}
                            listCheckedUsers={selectedUserForStaff}
                            isDisabled={false}
                          />
                          {formik.touched.user_id && formik.errors.user_id ? (
                            <div className="text-danger mt-2">
                              {formik.errors.user_id}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </>
                  )
                )
              }

              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label">
                    {t("Name")} <span className="text-danger">*</span>
                  </Label>
                  <Input
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder={t("Enter your name")}
                    value={formik?.values?.name}
                    onChange={(event: any) =>
                      formik.setFieldValue("name", event?.target?.value)
                    }
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="text-danger mt-2">{formik.errors.name}</div>
                  ) : null}
                </div>
              </Col>
              
              {
                 (
                  <>
                    <Col xxl={6}>
                      <label className="form-label">{t("Avatar")}</label>
                      <UploadImageSingle
                        data={formik.getFieldProps("image")?.value}
                        setLinkImage={null}
                        formik={formik}
                        isMultiple={false}
                        uploadProps={{
                          name: "files",
                          accept: "image/png,image/jpeg,image/*",
                          beforeUpload: () => false,
                          headers: {
                            authorization: "authorization-text",
                          },
                        }}
                        formikNameImage={"image"}
                      />
                    </Col>
                  </>
                )
              }
              
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="phone" className="form-label">
                    {t("Phone Number")}
                  </Label>
                  <Input
                    name="phone"
                    type="text"
                    className="form-control"
                    id="phone"
                    placeholder={t("Enter your phone number")}
                    value={formik?.values?.phone}
                    onChange={(event: any) =>
                      formik.setFieldValue("phone", event?.target?.value)
                    }
                  />
                  {formik.touched.phone && formik.errors.phone ? (
                    <div className="text-danger mt-2">
                      {formik.errors.phone}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col xxl={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Gender")}</Label>

                  <DropdownOptionNew
                    name="gender"
                    dataList={LIST_OPTION_GENDER || []}
                    placeholder={`${t("Gender")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.gender || null}
                    onChangeSelect={(event: any) =>
                      formik.setFieldValue("gender", event?.value)
                    }
                    isHasOptionAll={false}
                    hideSelectedOptions={false}
                  />

                  {formik?.touched?.gender && formik?.errors?.gender ? (
                    <div className="text-danger mt-2">
                      {/* {formik?.errors?.gender} */}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col lg={6} className="datepicker-time">
                <div className="mb-3">
                  <Label htmlFor="started_at" className="form-label">
                    {t("Start Time")} <span className="text-danger">*</span>
                  </Label>

                  <div className="w-100">
                    <DatePicker
                      name={"started_at"}
                      className="form-control"
                      selected={formik?.values?.started_at}
                      placeholderText={t("Select working start time")}
                      onChange={(date: any) => {
                        formik.setFieldValue("started_at", date);
                      }}
                      dateFormat="yyyy-MM-dd"
                      isClearable={true}
                    />
                  </div>

                  {formik.touched.started_at && formik.errors.started_at ? (
                    <div className="text-danger mt-2">
                      {/* {formik.errors.started_at} */}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col xxl={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Status")}</Label>

                  <DropdownStatusNew
                    name="status"
                    dataList={LIST_OPTION_BAR_DETAIL_REVIEW_STATUS || []}
                    placeholder={`${t("Status")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.status}
                    onChangeSelect={(event: any) =>
                      formik.setFieldValue("status", event?.value)
                    }
                    colors={COLOR_BAR_DETAIL_REVIEW_STATUS}
                  />

                  {formik?.touched?.status && formik?.errors?.status ? (
                    <div className="text-danger mt-2">
                      {formik?.errors?.status}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col xxl={6}>
                <div className="mb-3">
                  <Label className="form-label">{t("Approved Status")}</Label>

                  <DropdownStatusNew
                    name="approved_status"
                    dataList={
                      LIST_OPTION_BAR_DETAIL_STAFF_APPROVED_STATUS || []
                    }
                    placeholder={`${t("Select Approved Status")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.approved_status}
                    onChangeSelect={(event: any) =>
                      formik.setFieldValue("approved_status", event?.value)
                    }
                    colors={COLOR_BAR_DETAIL_STAFF_APPROVED_STATUS}
                  />

                  {formik?.touched?.approved_status &&
                  formik?.errors?.approved_status ? (
                    <div className="text-danger mt-2">
                      {formik?.errors?.approved_status}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col lg={12}>
                <div>
                  <Label className="form-label">{t("Hashtag")}</Label>
                  <div className="d-flex gap-2">
                    <div className="w-100">
                      <Keywords
                        name="keywords"
                        placeholder={`${t("Enter your hashtag")}...`}
                        suggestions={[]}
                        initialValue={formik?.values?.hashtags}
                        onChangeTag={(event) => {
                          // console.log(event)
                          // const keywords = event?.map((item) => item.text);
                          if(event?.length > 3) return;

                          setInitialValueHashTag(event);
                          formik.setFieldValue("hashtags", event);
                        }}
                      />
                    </div>
                    
                    <button
                      type="button"
                      className="btn btn-primary whitespace-nowrap"
                      style={{height: '39px'}}
                      onClick={()=> {
                        setIOpenHashTag(true)
                      }}
                    >
                      {t("Hashtag")}
                    </button>
                  </div>
                  
                  {formik?.touched?.hashtags && formik?.errors?.hashtags ? (
                    <div className="text-danger mt-2">
                      {formik?.errors?.hashtags}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col xxl={12} className="date-picker-wrapper-custom mt-3 mt-md-2">
                <div className="mb-3">
                  <Label className="form-label">{t("Bio")}</Label>

                  <textarea
                    className="form-control"
                    id="bio"
                    name="bio"
                    value={formik?.values?.bio}
                    placeholder={`${t("Please enter your introduction")}...`}
                    onChange={(event: any) =>
                      formik.setFieldValue("bio", event?.target?.value || "")
                    }
                    style={{ height: 80 }}
                  />
                </div>
              </Col>

              <Col lg={12}>
                <div className="hstack gap-2 justify-content-end">
                  {isHavePermissionRole(
                    ROLES_FOR_APP.USER_UPDATE,
                    userPermissions
                  ) && (
                    <button
                      className="btn btn-primary fs-14"
                      color="success"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Spinner size="sm" className="me-2"></Spinner>
                      ) : (
                        <>
                          {id
                            ? t("Button Update Bartender")
                            : t("Button Create Bartender")}
                        </>
                      )}
                    </button>
                  )}
                  {/* <button className="btn btn-soft-secondary fs-14" type="button" color="light" onClick={onCloseClick} disabled={isLoading}>
                        <i className="ri-indeterminate-circle-line align-bottom me-1"></i>
                        {t('Button Close')}
                    </button> */}
                </div>
              </Col>
            </Row>
          </form>
        </Container>

        {isOpenHashTag && (
          <ModalHashTag
            hashtags={formik?.values?.hashtags}
            listHashtag={listHashtag}
            onClose={handleCloseHashTag}
            onConfirm={handleConfirmHashTag}
            numMaxHashtag={3 - initialValueHashTag?.length || 0 }
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default StaffForm;
